/*
 * Product-bound status only. Klaviyo still owns real stars and review content.
 * Never turn a loading failure into "zero reviews" or borrow another SKU's data.
 */
(function () {
  'use strict';

  function init(section) {
    if (section.dataset.ukReviewsStatusReady) return;
    section.dataset.ukReviewsStatusReady = 'true';
    var productId = section.dataset.ukReviewsProductId;
    var widget = section.querySelector('#klaviyo-reviews-all');
    var panel = section.querySelector('[data-uk-reviews-fallback]');
    var status = section.querySelector('[data-uk-reviews-status]');
    var links = Array.prototype.filter.call(document.querySelectorAll('[data-uk-review-link]'), function (link) {
      return link.dataset.ukReviewLink === productId;
    });
    var badges = Array.prototype.filter.call(document.querySelectorAll('.klaviyo-star-rating-widget[data-id]'), function (badge) {
      return badge.dataset.id === productId;
    });
    if (!productId || !widget || !panel || !status) return;

    var message = 'Customer reviews are loading.';
    var linkLabel = 'Read customer reviews';
    var settled = false;

    function hasContent(element) {
      return Boolean(element && element.textContent.trim());
    }

    function sync() {
      var reviewsVisible = hasContent(widget);
      panel.hidden = reviewsVisible || !settled;
      status.textContent = message;
      var starsVisible = badges.some(hasContent);
      links.forEach(function (link) {
        link.href = '#' + section.id;
        link.textContent = linkLabel;
        link.hidden = starsVisible || !settled;
      });
    }

    var observer = new MutationObserver(sync);
    observer.observe(widget, { childList: true, subtree: true, characterData: true });
    badges.forEach(function (badge) {
      observer.observe(badge, { childList: true, subtree: true, characterData: true });
    });

    var script = document.querySelector('script[src*="static.klaviyo.com/onsite/js/"][src*="klaviyo.js"]');
    var companyId = '';
    if (script) {
      var scriptUrl = new URL(script.src, location.href);
      var pathMatch = scriptUrl.pathname.match(/\/onsite\/js\/([A-Za-z0-9]+)\/klaviyo\.js$/);
      companyId = scriptUrl.searchParams.get('company_id') || (pathMatch && pathMatch[1]) || '';
    }

    function unavailable() {
      settled = true;
      message = 'Customer reviews are temporarily unavailable. Please refresh this page to try again.';
      sync();
    }

    if (!companyId) {
      unavailable();
      return;
    }

    var url = new URL('https://fast.a.klaviyo.com/reviews/api/client_reviews/');
    url.searchParams.set('company_id', companyId);
    url.searchParams.set('products', JSON.stringify([productId]));
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 8000);

    fetch(url.href, { signal: controller.signal, credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Review status unavailable');
        return response.json();
      })
      .then(function (data) {
        var product = (data.products || []).find(function (item) {
          return String(item.external_id || item.shopify_id) === productId;
        });
        if (!product || !Number.isInteger(product.review_count) || product.review_count < 0) {
          throw new Error('Product review count unavailable');
        }
        settled = true;
        if (product.review_count === 0) {
          message = 'No reviews yet for this product.';
          linkLabel = 'No reviews yet';
        } else {
          message = 'Customer reviews are loading. If they do not appear, please refresh this page.';
          linkLabel = 'Read ' + product.review_count + (product.review_count === 1 ? ' review' : ' reviews');
        }
        sync();
      })
      .catch(unavailable)
      .finally(function () { clearTimeout(timeout); });
    sync();
  }

  function boot(root) {
    if (root.matches && root.matches('[data-uk-reviews-product-id]')) init(root);
    root.querySelectorAll('[data-uk-reviews-product-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
